import { Grid } from '@mui/material';
import { Link } from 'react-router-dom';
import styles from './Footer.module.scss';

interface FooterType {
  withMarginTop: boolean,
  withBackgroundColor: boolean
}

export const Footer = ({withMarginTop, withBackgroundColor} : FooterType)  => {

  return (
    <>
      {withMarginTop && <Grid
        container
        bgcolor = {withBackgroundColor ? "background.default" : "none"}
        px={3.75}
        py={3.75}
        sx={{
          height: { xs: 191, sm: 250 },
          borderBottom: '1px solid white',
          alignItems: {
            sm: 'center',
          },
        }}
      ></Grid>}
      <Grid
        container
        px={3.75}
        bgcolor = {withBackgroundColor ? "background.default" : "none"}
        sx={{ color: '#777777', fontSize: 12 }}
        spacing={1}
      >
        <Grid item xs={12} lg={7} display="flex" alignItems="flex-end" marginBottom={3} sx={{ opacity: 0.5 }}>
          TheGuarantors is a licensed insurance agent and broker. We provide
          options for coverage by sourcing it through one of our insurance
          partners. For more detailed information on either our licenses or any
          of our insurance partners, please see our Legal/Regulatory Notice.
        </Grid>
        <Grid item xs={12} lg={5} sx={{ opacity: 0.5 }}>
          <Grid container spacing={2} mt={2.4}>
            <Grid
              item
              sm={3.5}
              sx={{ display: { sm: 'block', xs: 'none' } }}
              xs={12}
              mb={3}
            >
              © 2023 TheGuarantors
            </Grid>

            <Grid item sm={2.5} xs={7} mb={2}>
              <Link
                target="_blank"
                to={'//www.theguarantors.com/privacy?hsLang=en'}
                className={styles.link}
              >
                Privacy Policy
              </Link>
            </Grid>
            <Grid item sm={2.5} xs={5} mb={2}>
              <Link
                target="_blank"
                to={'//www.theguarantors.com/terms?hsLang=en'}
                className={styles.link}
              >
                Terms of Service
              </Link>
            </Grid>
            <Grid item sm={1} xs={7} mb={2}>
              <Link
                target="_blank"
                to={'//www.theguarantors.com/legal-regulatory?hsLang=en'}
                className={styles.link}
              >
                Legal
              </Link>
            </Grid>
            <Grid item sm={2.5} xs={5} mb={2}>
              <Link
                target="_blank"
                to={'//www.theguarantors.com/legal-regulatory?hsLang=en'}
                className={styles.link}
              >
                Regulatory Notice
              </Link>
            </Grid>
          </Grid>
        </Grid>
        <Grid container>
          <Grid
            item
            sx={{ opacity: 0.5, display: { sm: 'none' } }}
            xs={12}
            mb={2}
          >
            © 2023 TheGuarantors
          </Grid>
        </Grid>
      </Grid>
    </>
  );

};
